export default {
  commentsPlaceholder: {
    en: 'Leave a comment...',
  },
}
